import { memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

import { WORKSPACE_PANEL_COLLAPSE_SLOT_CLASS } from '~/components/v2/components/shared/page-header/pageHeaderLayout';
import { WorkspacePanelCollapseSlot } from '~/components/v2/components/shared/page-header/WorkspacePanelCollapseSlot';
import { useWorkspaceSplitPageTopbar } from '~/components/v2/components/shared/panel/useWorkspaceSplitPageTopbar';

export const PAGE_HEADER_TOOLBAR_GRID_CLASS = 'grid grid-cols-[minmax(0,1fr)_auto] items-center gap-x-2 px-4';

export type PageHeaderToolbarGridProps = {
  children: ReactNode;
  className?: string;
  gridClassName?: string;
};

/** Two-column page header row: primary content on the left, workspace collapse on the right when split. */
export const PageHeaderToolbarGrid = memo(({ children, className, gridClassName }: PageHeaderToolbarGridProps) => {
  const showSplitPageTopbar = useWorkspaceSplitPageTopbar();

  return (
    <div className={className}>
      <div className={cn(PAGE_HEADER_TOOLBAR_GRID_CLASS, gridClassName)}>
        <div className="min-w-0">{children}</div>
        {showSplitPageTopbar && (
          <div className={WORKSPACE_PANEL_COLLAPSE_SLOT_CLASS}>
            <WorkspacePanelCollapseSlot />
          </div>
        )}
      </div>
    </div>
  );
});

PageHeaderToolbarGrid.displayName = 'PageHeaderToolbarGrid';
